import starIcon from '../../../../assets/plans/star-icon.svg';

const Credits = ({ credits }) => {
  return (
    <div className="credits-container">
      <span className="credits-icon">
        <img className="icon" src={starIcon} alt="Credits Icon" />
      </span>
      <span className="credits">{credits}</span>
      <style jsx>
        {`
          .credits-container {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            gap: 8px;
            background-color: var(--theme-color);
            margin-right: 16px;
            padding: 5px 12px;
            border-radius: 8px;
          }
          .credits-icon {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .icon {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
          }
          .credits {
            font-size: 16px;
            font-weight: 600;
            color: var(--btn-purple-color);
          }
          @media (max-width: 768px) {
            .credits-container {
              padding: 2px 8px;
              gap: 4px;
            }
            .icon {
              width: 18px;
              height: 18px;
            }
            .credits {
              font-size: 14px;
            }
          }
          @media (max-width: 480px) {
            .credits {
              font-size: 12px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Credits;
